module.exports = __webpack_public_path__ + "img/standard.19fb641b.png";